import { render, staticRenderFns } from "./GroupRainbowIcon.vue?vue&type=template&id=3d3c37ce&"
import script from "./GroupRainbowIcon.vue?vue&type=script&lang=js&"
export * from "./GroupRainbowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports